/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Receipt_Load_ErrorInputs */



/**
* | output |
* | --- |
* | "This bill could not be loaded. It may not exist, or it belongs to another partner." |
*
* @param {Partner_Receipt_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_receipt_load_error = /** @type {((inputs?: Partner_Receipt_Load_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Receipt_Load_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Abrechnung konnte nicht geladen werden. Sie existiert nicht oder gehört zu einem anderen Partner.")
	return /** @type {LocalizedString} */ ("This bill could not be loaded. It may not exist, or it belongs to another partner.")
});